import { useLocation } from '@ecomm/framework/useLocation'
import { useMemo } from 'react'

export const usePagePath = () => {
  const location = useLocation()
  const { pathname } = location

  return useMemo(() => pathname, [pathname])
}
